import { getBaseUrl, logBamErrors } from '.';

export type ComplianceConfig = {
    blocked: boolean;
    message: string;
    link: string;
};

export const defaultConfig: ComplianceConfig = {
    blocked: false,
    message: '',
    link: '',
};

type fetchProps = {
    identifiers: string;
    propertyId: number;
    location: string;
    devMode: boolean;
};

export async function getComplianceConfig({ identifiers, propertyId, location, devMode }: fetchProps) {
    const requests = identifiers
        .replace(/ /g, '')
        .split(',')
        .map(identifier => {
            return fetchComplianceConfig({
                propertyId: propertyId,
                identifier,
                location: location,
                devMode: devMode,
            });
        });

    try {
        const responses = await Promise.all(requests);

        return responses.find(response => response.blocked) || defaultConfig;
    } catch (err) {
        logBamErrors([err.message], 'Page Blocker');
        return defaultConfig;
    }
}

function fetchComplianceConfig(params: { propertyId: number; identifier: string; location: string; devMode: boolean }) {
    const baseUrl = getBaseUrl(params.devMode);
    const url = `${baseUrl}/v1/auxiliary/compliance_tag_lookup/${params.propertyId}/${params.identifier}${
        params.location ? `?location=${params.location}` : ''
    }`;

    return fetch(url)
        .then(res => {
            if (!res.ok) {
                throw new Error('Network response was not ok');
            }
            return res.json();
        })
        .catch(err => {
            throw new Error(err);
        }) as Promise<ComplianceConfig>;
}
